import { unref } from 'vue'

export const useGetSlugSegments = (
  dataInput: any,
  lang: 'cs' | 'en' = 'cs',
): string[] => {
  const data = unref(dataInput)

  if (!data) return []

  const fullUrl = data?.breadcrumbs?.[lang]?.at(-1)?.menu_url

  if (fullUrl) {
    return fullUrl.split('/').filter(Boolean)
  }

  const directUrl = data?.menu_url?.[lang] || data?.menu_url
  if (typeof directUrl === 'string') {
    return directUrl.split('/').filter(Boolean)
  }

  const fallbackSlug = data?.slug?.[lang] || data?.slug
  return fallbackSlug ? fallbackSlug.split('/').filter(Boolean) : []
}
